window.rowStyleFormatter = function(row) {
    if (row.rowstyle) {
        return {
            classes: row.rowstyle
        };
    }
    return {};
};
